import { DISMISS_OTHER_REGIONS_ALERT } from "./types";

export const dismissOtherRegionsAlert = () => ({
  type: DISMISS_OTHER_REGIONS_ALERT
});
